const BACKEND_ASSET_PATHS = ['/images/', '/storage/'];

const sanitizeEnvValue = (value) => {
  if (typeof value !== 'string') {
    return '';
  }

  return value.trim().replace(/^['"]|['"]$/g, '');
};

const getBackendOrigin = () => {
  const baseUrl = sanitizeEnvValue(process.env.REACT_APP_BASE_URL);

  if (!baseUrl) {
    return '';
  }

  try {
    return new URL(baseUrl).origin;
  } catch (error) {
    return '';
  }
};

export const normalizeBackendAssetUrl = (value) => {
  if (!value || typeof value !== 'string') {
    return value;
  }

  const trimmed = value.trim();
  if (!trimmed || /^(data:|blob:|about:|chrome-extension:)/i.test(trimmed)) {
    return trimmed;
  }

  const backendOrigin = getBackendOrigin();

  try {
    const parsed = new URL(trimmed);
    return parsed.toString();
  } catch (error) {
  }

  const relativePath = trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
  const isBackendAssetPath = BACKEND_ASSET_PATHS.some((prefix) => relativePath.startsWith(prefix));

  if (isBackendAssetPath && backendOrigin) {
    return `${backendOrigin}${relativePath}`;
  }

  if (typeof window === 'undefined') {
    return trimmed;
  }

  try {
    return new URL(trimmed, window.location.origin).toString();
  } catch (error) {
    return trimmed;
  }
};
